import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SubscriptionService from "../../services/SubscriptionService";

export const fetchSubscriptions = createAsyncThunk(
  "subscription/fetchSubscriptions",
  async () => {
    try {
      const res = await SubscriptionService.getSubscriptions();
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchUserSubscriptionsHistory = createAsyncThunk(
  "subscription/fetchUserSubscriptionsHistory",
  async (data) => {
    try {
      const res = await SubscriptionService.getUserSubscriptionHistory(data);
      console.log("RED", res);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  subscriptions: [],
  paymentConfig: null,
  subscriptionHistories: [],
  total_pages: 0,
  total_records: 0,
};

const subscriptionsSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //Get All SUBSCRIPTIONS
    builder
      .addCase(fetchSubscriptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubscriptions.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.subscriptions = payload?.data;
        state.paymentConfig = payload?.pay_tab_config;
      })
      .addCase(fetchSubscriptions.rejected, (state) => {
        state.loading = false;
      });

    //Get All USER SUBSCRIPTIONS HISTORY
    builder
      .addCase(fetchUserSubscriptionsHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchUserSubscriptionsHistory.fulfilled,
        (state, { payload }) => {
          state.loading = false;
          state.subscriptionHistories = payload?.data?.data;
          state.total_pages = payload?.data?.total_pages;
          state.total_records = payload?.data?.total_records;
        }
      )
      .addCase(fetchUserSubscriptionsHistory.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default subscriptionsSlice.reducer;
